import api from "./api";

export async function getDriverOrderTypes(driverId) {
  const res = await api.get(`/admin/order-types/${driverId}`);
  return res.data.data;
}

export async function attachOrderType(driverId, orderTypeId) {
  const res = await api.post("/admin/order-types/attach", {
    id_driver: driverId,
    id_orderType: orderTypeId
  });
  return res.data.data;
}

export async function detachOrderType(driverId, orderTypeId) {
  const res = await api.post("/admin/order-types/detach", {
    id_driver: driverId,
    id_orderType: orderTypeId
  });
  return res.data.data;
}